/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvcameraTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Nvcamera {
    [k: string]: any;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "MinMax".
 */
export interface MinMax {
    min?: number;
    max?: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "AnselRedirectionParams".
 */
export interface AnselRedirectionParams {
    enable?: boolean;
    mode?: Mode;
    hid?: Hid;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "NvCameraResponseNotificationReturn".
 */
export interface NvCameraResponseNotificationReturn {
    /**
     * Capture control changed notification
     */
    anselEnabledResponse?: {
        capture?: AnselStatusEnum;
    };
    /**
     * Capture control changed notification
     */
    ipcVersion?: {
        compatible: boolean;
        anselVersion: string;
        shareVersion: string;
    };
    /**
     * Get Ansel Enabled Response notification
     */
    anselEnabledStatus?: {
        anselStatus: AnselStatus;
    };
    /**
     * Get Ansel Enabled Response notification
     */
    anselEnabledState?: {
        anselState?: AnselState;
    };
    /**
     * Game proc info (pid/path) notification
     */
    procInfo?: {
        /**
         * PID of game
         */
        procId?: number;
        /**
         * Full path of game exe
         */
        procPath?: string;
    };
    /**
     * Supported capture type by NvCamera
     */
    captureTypesList?: {
        /**
         * Is EXR allowed
         */
        exrAllowed?: boolean;
        /**
         * Array of supported types [up to 5]
         */
        captures?: CaptureTypes[];
    };
    /**
     * Get whether SDK is integrated
     */
    sdkIntegration?: {
        /**
         * True or False
         */
        sdkIntegrationAvailable?: boolean;
    };
    rollRange?: MinMax;
    fovRange?: MinMax;
    /**
     * Set fov status response
     */
    setRollFovResponse?: {
        status?: AnselStatusEnum;
        response?: Response;
    };
    /**
     * Current fov value
     */
    fovValue?: {
        fov: number;
    };
    /**
     * Game resolution width/height of game
     */
    screenResolution?: {
        width?: number;
        height?: number;
    };
    /**
     * Array of supported resolutions for highRes type
     */
    highResResolutions?: {
        resolutionArray?: {
            multiplier: number;
            width?: number;
            height?: number;
        }[];
    };
    /**
     * Supported resolutions as minX/maxX range for 360 capture type as
     */
    panoramaResolutions?: {
        minX: number;
        maxX: number;
    };
    /**
     * Capture shot started successfully or not with shot count
     */
    captureShotStarted?: {
        status?: AnselStatusEnum;
        shotCount?: number;
        screenshot?: string;
    };
    /**
     * Capture shot progress status
     */
    captureShotProgress?: {
        currentShot?: number;
        screenshot?: string;
    };
    /**
     * Capture shot finished status
     */
    captureShotFinished?: {
        status: AnselStatusEnum;
        captureType: CaptureTypes;
        captureStatus: string;
    };
    /**
     * Capture shot finished status
     */
    captureShotProcessingFinished?: {
        captureType: CaptureTypes;
        path: string;
        captureStatus: string;
        status: AnselStatusEnum;
    };
    /**
     * Cancel the capture in progress
     */
    captureShotCancel?: {
        status?: AnselStatusEnum;
    };
    /**
     * Array of available feature set
     */
    features?: {
        featureSet?: FeaturesSupported[];
    };
    /**
     * Filter list details as id/name pairs
     */
    filtersList?: {
        filtersListArray?: {
            id?: string;
            name?: string;
        }[];
    };
    /**
     * Status of reset filter IPC
     */
    resetFilter?: {
        status?: AnselStatusEnum;
    };
    /**
     * Status of insert filter IPC
     */
    insertFilter?: {
        status?: AnselStatusEnum;
    };
    /**
     * Status of remove filter IPC
     */
    removeFilter?: {
        status?: AnselStatusEnum;
    };
    /**
     * Status of move filter IPC
     */
    moveFilter?: {
        status?: AnselStatusEnum;
    };
    /**
     * Status of setFilterAttribute
     */
    setFilterAttribute?: {
        status?: AnselStatusEnum;
    };
    /**
     * Array of filter ids in the stack
     */
    filterStackInfo?: {
        ids?: string[];
    };
    /**
     * Status of reset entire stack IPC
     */
    resetEntireStack?: {
        status?: AnselStatusEnum;
    };
    /**
     * ansel status report
     */
    anselStatusReport?: {
        statusStrings?: string[];
        status?: AnselStatusEnum;
    };
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "NvCameraFilterResponseNotificationReturn".
 */
export interface NvCameraFilterResponseNotificationReturn {
    /**
     * Filter information details
     */
    filterDetails?: {
        filter?: {
            status?: AnselStatusEnum;
            /**
             * Index in the stack at this filter is applied
             */
            stackIdx?: number;
            /**
             * Filter id specified as name of the filter
             */
            id?: string;
            /**
             * Display name of the filter
             */
            filterDisplayName?: string;
        };
        /**
         * Sub controls of the filter. There could be multiple controls for each filter. So its an array
         */
        controls?: {
            /**
             * ID for the current control
             */
            id?: number;
            /**
             * Name for the current control
             */
            displayName?: string;
            /**
             * Type(slider/bool etc..) for the current control
             */
            controlType?: string;
            /**
             * Info for the current control
             */
            tooltip?: string;
            /**
             * Measure unit for the current control
             */
            measureUnit?: string;
            dataType?: DataType;
            /**
             * Array of control min values
             */
            minValue?: number[];
            /**
             * Array of control max values
             */
            maxValue?: number[];
            /**
             * Array of control default values
             */
            defaultValue?: number[];
            /**
             * Array of control current values
             */
            currentValue?: number[];
            /**
             * Array of control step size
             */
            stepSize?: number[];
            /**
             * Array of control step size
             */
            uiStepSize?: number[];
            /**
             * Array of UI min value
             */
            uiMinValueV1?: number[];
            /**
             * Array of UI max value
             */
            uiMaxValueV1?: number[];
            /**
             * Array of UI display names
             */
            uiDisplayNameV1?: string[];
            dataLabels?: string[];
            uiMinValue?: number;
            uiMaxValue?: number;
            /**
             * Default ID for pulldown/radio-button controls
             */
            defaultId?: number;
            /**
             * Current ID for pulldown/radio-button controls
             */
            currentId?: number;
        }[];
    };
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "NvCameraUIControlNotificationDataReturn".
 */
export interface NvCameraUIControlNotificationDataReturn {
    /**
     * Update game FOV value
     */
    updateFovValue?: {
        currentFovValue?: number[];
    };
    /**
     * Update game FOV value
     */
    updateRollValue?: {
        currentRollValue?: number[];
    };
    /**
     * Notify whether control is visible
     */
    uiControlSetVisibility?: {
        id?: number;
        visible: boolean;
    };
    /**
     * Notify whether control is visible
     */
    uiControlGetVisibility?: {
        id?: number;
    };
    /**
     * Remove all UI controls
     */
    uiControlRemoveAllRequest?: {
        removeAllControls?: boolean;
    };
    /**
     * Remove UI control for given ids
     */
    uiControlRemove?: {
        ids?: number[];
    };
    /**
     * NvCamera ready notification with the DX creation counter
     */
    nvCameraReady?: {
        deviceCreationCounter: number;
    };
    /**
     * Add UI control request
     */
    addUIElement?: {
        controlType?: string;
        controlId?: number;
        displayName?: string;
        visible?: boolean;
        /**
         * Array of control min values
         */
        minValue?: number[];
        /**
         * Array of control max values
         */
        maxValue?: number[];
        /**
         * Array of control default values
         */
        defaultValue?: number[];
        /**
         * Array of control current values
         */
        currentValue?: number[];
        /**
         * Array of control step size
         */
        stepSize?: number[];
    };
    /**
     * ansel status report
     */
    anselStatusReport?: {
        statusStrings?: string[];
        status?: AnselStatusEnum;
    };
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "NgxAIUpResNotificationsReturn".
 */
export interface NgxAIUpResNotificationsReturn {
    /**
     * Progress info for AI UpRes
     */
    ngxAIUpResProgress?: {
        progress?: number;
    };
    /**
     * AI UpRes failed notification
     */
    ngxAIUpResError?: {
        ngxErrorType?: string;
    };
    /**
     * AI UpRes success notification
     */
    ngxAIUpResCaptureDone?: {
        ngxAIUpResStatus?: NgxAiUpResStatus;
    };
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetAnselEnableParameters".
 */
export interface SetAnselEnableParameters {
    /**
     * Enable ansel session
     */
    sessionEnable: boolean;
    /**
     * Pause game when enable ansel session
     */
    pauseOnEnable?: boolean;
    /**
     * Leave filters applied for freestyle
     */
    leaveFiltersOn?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetNvCameraConfigReturn".
 */
export interface GetNvCameraConfigReturn {
    /**
     * Sets IPC enabled/disable regkey
     */
    ipcEnabled: boolean;
    /**
     * Sets freestyle enable/disable regkey
     */
    freestyleEnabled: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetVersionReturn".
 */
export interface GetVersionReturn {
    /**
     * Returns version info
     */
    version: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetLanguageParameters".
 */
export interface SetLanguageParameters {
    langId: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetNvCameraConfigParameters".
 */
export interface SetNvCameraConfigParameters {
    /**
     * Sets IPC enabled/disable regkey
     */
    ipcEnable?: boolean;
    /**
     * Sets freestyle enable/disable regkey
     */
    freestyleEnable?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "CaptureScreenshotParameters".
 */
export interface CaptureScreenshotParameters {
    /**
     * Specifies the type of capture to be taken
     */
    captureType: string;
    /**
     * Specifies the multiplier for highRes capture
     */
    resolutionMultiplier?: number;
    /**
     * Specifies the capture width
     */
    width?: number;
    /**
     * Specifies the capture height
     */
    height?: number;
    /**
     * Specifies the width for 360 capture
     */
    panoramaWidth?: number;
    /**
     * Specifies the height for 360 capture
     */
    panoramaHeight?: number;
    /**
     * Specifies HDR capture enable/disable
     */
    saveAsExr: boolean;
    /**
     * Specifies the enhance mode for highRes
     */
    enhance?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetCaptureResolutionsParameters".
 */
export interface GetCaptureResolutionsParameters {
    captureType: CaptureTypes;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetFilterParameters".
 */
export interface SetFilterParameters {
    /**
     * Set or reset filter
     */
    enable: boolean;
    /**
     * Index in stack that this filter will be applied
     */
    stackId?: number;
    /**
     * Full qualified name of the filter to be applied
     */
    filterId?: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetCurrentFilterInfoParameters".
 */
export interface GetCurrentFilterInfoParameters {
    stackId: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "ResetFilterParameters".
 */
export interface ResetFilterParameters {
    /**
     * Resets all filters
     */
    resetAll?: boolean;
    /**
     * Reset a single filter at give stack index
     */
    stackId: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "InsertFilterParameters".
 */
export interface InsertFilterParameters {
    stackId: number;
    filterId: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "RemoveFilterParameters".
 */
export interface RemoveFilterParameters {
    stackId: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "MoveFilterParameters".
 */
export interface MoveFilterParameters {
    /**
     * Array of current indices in the order that need to be set
     */
    filterOrder: number[];
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetFilterAttributeParameters".
 */
export interface SetFilterAttributeParameters {
    /**
     * Filter for which controls need to be changed
     */
    filter: string;
    controlId: number;
    controlType: number;
    stackId?: number;
    dataType: string;
    /**
     * Array of control current values
     */
    values: number[];
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetFilterAndAttributesParameters".
 */
export interface SetFilterAndAttributesParameters {
    /**
     * Filter for which controls need to be changed
     */
    filterId: string;
    /**
     * At what position the filter is to be applied
     */
    stackIdx: number;
    /**
     * Array of controls for the above filter
     */
    controls: {
        id: number;
        /**
         * Is it a slider/boolean etc?
         */
        type: number;
        values: number[];
        /**
         * Is the control value a string/boolean/float/integer etc?
         */
        dataType: string;
    }[];
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetCameraControlFovRollParameters".
 */
export interface SetCameraControlFovRollParameters {
    /**
     * Set to true
     */
    setFovRollEnable: boolean;
    setRollValue?: number;
    setFovValue?: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetCameraControlFovParameters".
 */
export interface GetCameraControlFovParameters {
    /**
     * Set to false to get current FOV
     */
    setFovRollEnable: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetCameraRangeFovRollParameters".
 */
export interface GetCameraRangeFovRollParameters {
    /**
     * Request for roll range
     */
    getCameraRoll?: boolean;
    /**
     * Request for fov range
     */
    getCameraFov?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetCameraGridOfThirdsParameters".
 */
export interface SetCameraGridOfThirdsParameters {
    enableGoT: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "MouseEventToNvcameraParameters".
 */
export interface MouseEventToNvcameraParameters {
    eventName: string;
    button?: number;
    coordinateX?: number;
    coordinateY?: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "KeyboardEventToNvcameraParameters".
 */
export interface KeyboardEventToNvcameraParameters {
    eventName: string;
    keyCode?: number;
    code?: string;
    shiftKey?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetFreestyleWhitelistedParameters".
 */
export interface GetFreestyleWhitelistedParameters {
    profileName: string;
}
/**
 * Returned True if game is whitelisted, false otherwise
 *
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "GetFreestyleWhitelistedReturn".
 */
export interface GetFreestyleWhitelistedReturn {
    freestyleWhitelisted?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "StartNgxAIUpResParameters".
 */
export interface StartNgxAIUpResParameters {
    inputFile: string;
    upResEffect: number;
    upResScale: number;
    width: number;
    height: number;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "CancelNgxAIUpResParameters".
 */
export interface CancelNgxAIUpResParameters {
    cancelAIUpRes?: boolean;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "AnselShotSavedNotificationParameters".
 */
export interface AnselShotSavedNotificationParameters {
    /**
     * Ansel screenshot
     */
    captureMode: string;
    /**
     * Fully-quantified path to the screenshot
     */
    path: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetCMSInfoParameters".
 */
export interface SetCMSInfoParameters {
    cmsId: string;
    shortName: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "SetLcarsClientIdParameters".
 */
export interface SetLcarsClientIdParameters {
    /**
     * LCARS client ID from the product config
     */
    clientId: string;
    /**
     * Product version string for NV-Client-Version header
     */
    clientVersion: string;
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "ChromaDataNotificationReturn".
 */
export interface ChromaDataNotificationReturn {
    /**
     * CMS ID of the game
     */
    cmsId?: number;
    /**
     * Process ID of the game
     */
    pid?: number;
    /**
     * DRS profile name of the game
     */
    profileName?: string;
    /**
     * App ID from the chroma server response
     */
    id?: string;
    /**
     * App title from the chroma server response
     */
    title?: string;
    /**
     * NVIDIA technology support flags
     */
    nvidiaTech?: {
        FREESTYLE?: boolean;
        PHOTO_MODE?: boolean;
        RTXDVC?: boolean;
        HIGHLIGHTS?: boolean;
        HDR?: boolean;
        NGX?: boolean;
        REFLEX?: boolean;
        REFLEXFLASHINDICATOR?: boolean;
        REFLEXFIAUTO?: boolean;
        REFLEXSTATS?: boolean;
        GAMEASSIST?: boolean;
    };
}

/**
 * Ansel status mapped as string
 *
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "AnselStatusEnum".
 */
export enum AnselStatusEnum {
    ok = 'ok',
    failed = 'failed',
    started = 'started',
    failedToStart = 'failedToStart',
    noSpace = 'noSpace',
    permissionDenied = 'permissionDenied',
    invalidRequest = 'invalidRequest',
    failedToProcess = 'failedToProcess',
    processDeclined = 'processDeclined',
    alreadyEnabled = 'alreadyEnabled',
    alreadyDisabled = 'alreadyDisabled',
    outOfRange = 'outOfRange',
    alreadySet = 'alreadySet',
    incompatibleVersion = 'incompatibleVersion',
    disabled = 'disabled',
    okAnsel = 'okAnsel',
    okModsOnly = 'okModsOnly',
    failedToFinishCapture = 'failedToFinishCapture',
    failedToSaveShotFailedCreateDiretory = 'failedToSaveShotFailedCreateDiretory',
    failedToSaveShotNoSpaceLeft = 'failedToSaveShotNoSpaceLeft',
    processingCompleted = 'processingCompleted',
    shotSaved = 'shotSaved',
    processingFile = 'processingFile',
    failedToSaveShot = 'failedToSaveShot'
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "CaptureTypes".
 */
export enum CaptureTypes {
    regular = 'regular',
    stereoRegular = 'stereoRegular',
    highRes = 'highRes',
    sphericalPanorama = 'sphericalPanorama',
    stereoSphericalPanorama = 'stereoSphericalPanorama'
}
/**
 * This interface was referenced by `Nvcamera`'s JSON-Schema
 * via the `definition` "FeaturesSupported".
 */
export enum FeaturesSupported {
    sdk = 'sdk',
    mods = 'mods',
    styleTransfer = 'styleTransfer',
    allowOffline = 'allowOffline',
    none = 'none'
}
export enum Mode {
    windowedSDK = 'windowedSDK',
    fullscreenSDK = 'fullscreenSDK',
    windowedNoSDK = 'windowedNoSDK',
    fullscreenNoSDK = 'fullscreenNoSDK'
}
export enum Hid {
    mouse = 'mouse',
    keyboard = 'keyboard',
    gamepad = 'gamepad'
}
export enum AnselStatus {
    notEnabled = 'notEnabled',
    enabled = 'enabled'
}
/**
 * notAvailable/available indicate nvcamera is on MBus. notEnabled/enabled indicate ansel session
 */
export enum AnselState {
    notAvailable = 'notAvailable',
    available = 'available',
    notEnabled = 'notEnabled',
    enabled = 'enabled'
}
export enum Response {
    roll = 'roll',
    fov = 'fov'
}
/**
 * Data representation for the current control
 */
export enum DataType {
    float = 'float',
    int = 'int',
    uint = 'uint',
    bool = 'bool'
}
export enum NgxAiUpResStatus {
    success = 'success'
}


}
